import {connect} from 'react-redux';
import axios from 'axios';
import { Platform} from "react-native";
import ApplyScreen from "../ApplyScreen";
import {typeExport} from "../../../../../redux/store/type";
import store from "../../../../../redux/store";

const mapStateToProps = (state) => ({
    results: state.reducerApplyScreen.results,
    isLoading: state.reducerApplyScreen.isLoading,
    NoInternetDialog: state.reducerApplyScreen.NoInternetDialog,

    resultsSet: state.reducerApplyScreen.resultsSet,
    isLoadingSet: state.reducerApplyScreen.isLoadingSet,
    NoInternetDialogSet: state.reducerApplyScreen.NoInternetDialogSet,

    position: state.reducerApplyScreen.position,
    id_category: state.reducerApplyScreen.id_category,


    positionPersonnel: state.reducerApplyScreen.positionPersonnel,
    id_Personnel: state.reducerApplyScreen.id_Personnel,

    CartList: state.reducerSplashGetAllData.CartList,
    PriceAll: state.reducerSplashGetAllData.PriceAll,

    user: state.reducerSplashGetAllData.user,
    wallet: state.reducerSplashGetAllData.wallet,
    DataSplashScreen: state.reducerSplashGetAllData,
    // token: state.reducerSplash.token,

    FoodItem: state.reducerSplashGetAllData.FoodItem,
});

const mapDispatchToProps = (dispatch) => ({
    callService: (url, params, type, typeConnection, token) => dispatch(callWebservice(url, params, type, typeConnection, token)),

    callServiceRefresh: () => dispatch(serviceActionRefresh()),

});

const getDataDisatch = (dispatch, url, params, type, typeConnection, token) => {

    switch (type) {
        case typeExport.TypeGetApplyScreen:
            dispatch(serviceActionPending());

            break;

        case typeExport.TypeSetApplyScreen:
            dispatch(serviceActionPendingSet());

            break;

        default:
    }
    axios(
        {
            // url: baseUrl + url + params,
            // url: url+"&after=0000-00-00" ,
            url: url,
            method: typeConnection,
            params: params,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            timeout: typeExport._TIMEOUT,
            /*      headers: {'X-Requested-With': 'XMLHttpRequest'},*/
        }
    ).then(response => {
        let data = response.data;
        switch (type) {
            case typeExport.TypeGetApplyScreen:
                //if (response.data.status === true) {
                // dispatch(serviceActionSuccess(data, token, response.data.user));
                dispatch(serviceActionSuccess(data));

                //   NavigationService.navigatereset('MainStack');
                // }
                // else {
                //  //   NavigationService.navigatereset('LoginStack');
                // }
                break;

            case typeExport.TypeSetApplyScreen:

                break;

            default:
        }
    }).catch((e) => {

        switch (type) {
            case typeExport.TypeGetApplyScreen:
                dispatch(serviceActionError(e))

                break;

            case typeExport.TypeSetApplyScreen:
                dispatch(serviceActionErrorSet(e))

                break;

            default:
        }
    })
}


// export const callSetStateCity =  (state_name,state_id,city_name,city_id)  => {

//     return dispatch (serviceActionSuccessSetCityStateData (state_name,state_id,city_name,city_id) )
// }
export const callWebservice = (url, params, type, typeConnection, token) => {
    return dispatch => {

        // if (Platform.OS === 'ios') {
        //     NetInfo.isConnected.addEventListener('connectionChange', (isConnected) => {
        //             if (isConnected) {
        //                 getDataDisatch(dispatch, url, params, type, typeConnection, token);
        //             }
        //             else {
        //                 dispatch(serviceActionError("No Internet Connection"));
        //             }
        //         }
        //     );
        // }
        // else {
        // NetInfo.isConnected.fetch().then((isConnected) => {
        //     if (isConnected) {
        //         getDataDisatch(dispatch, url, params, type, typeConnection, token);
        //     }
        //     else {
        //         switch (type) {
        //
        //             case typeExport.TypeGetApplyScreen:
        //                 dispatch(serviceActionError("no connect"));
        //                 break;
        //             default:
        //         }
        //     }
        // });


        if (store.getState().reducerSplashGetAllData.Connection) {
            getDataDisatch(dispatch, url, params, type, typeConnection, token);
        }
        else {
            switch (type) {
                case typeExport.TypeGetApplyScreen:
                    dispatch(serviceActionError('error_Connection'))

                    break;

                case typeExport.TypeSetApplyScreen:
                    dispatch(serviceActionErrorSet('error_Connection'))

                    break;

                default:
            }
        }
        //}

        /* NetInfo.getConnectionInfo().done(
             (isConnected) => {
                 if (isConnected) {
                     getDataDisatch(dispatch, url, params, type, typeConnection, token);
                 }
                 else {
                     switch (type) {

                         case typeExport.TypeGetApplyScreen:
                             dispatch(serviceActionError("no connect"));
                             break;
                         default:
                     }
                 }
             }
         )*/
    }
}


export const serviceActionPending = () => ({
    type: typeExport.ApplyScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    isLoading: true,
    showDialohCity: false

})

export const serviceActionError = (error) => ({
    type: typeExport.ApplyScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    error: error,
    isLoading: false,
    showDialohCity: false

})

export const serviceActionSuccess = (data) => ({
    type: typeExport.ApplyScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    results: data,
    isLoading: false,
})

export const serviceActionPendingSet = () => ({
    type: typeExport.ApplyScreen_SERVICE_PENDING_Set,
    NoInternetDialogSet: false,
    isLoadingSet: true,

})

export const serviceActionErrorSet = (error) => ({
    type: typeExport.ApplyScreen_SERVICE_ERROR_Set,
    NoInternetDialogSet: true,
    error: error,
    isLoadingSet: false,

})

export const serviceActionSuccessSet = (data) => ({
    type: typeExport.ApplyScreen_SERVICE_SUCCESS_Set,
    NoInternetDialogSet: false,
    resultsSet: data,
    isLoadingSet: false,
})
export const serviceActionRefresh = () => ({
    type: typeExport.ApplyScreen_SERVICE_REFRESH,
    NoInternetDialog: false,
    results: null,
    isLoading: false,
})


export default connect(mapStateToProps, mapDispatchToProps)(ApplyScreen);
